import { Currency } from '@teko/ds-desktop';
import { DiscountBenefit, Gift, VoucherPromotion } from '@teko/ecommerce';
import { Link, StyledCurrency } from 'components/ProductDetail/styles';
import { t } from 'i18n';
import React from 'react';
import {
  BENEFIT_TYPE,
  ExtraCustomPromotion,
  ExtraPromotion,
  PROMOTION_TYPE,
  ProductDetailBenefit,
  ProductDetailPromotion,
} from '../types';

export interface RelatedPromotionProps {
  promotion: ProductDetailPromotion;
}

const renderDetailPromotionContent = (
  benefitType: string,
  data: ProductDetailBenefit,
) => {
  switch (benefitType) {
    case BENEFIT_TYPE.discount:
      const { percent, maxAmount, flat } = data as DiscountBenefit;
      return percent !== null ? (
        <>
          {t('{{percent}}% tối đa', { percent: percent })}{' '}
          <StyledCurrency value={maxAmount || 0} />
        </>
      ) : (
        <StyledCurrency value={flat || 0} />
      );
    case BENEFIT_TYPE.gifts:
      return (
        <strong>
          {(data as Gift[])
            .map(({ name, quantity }) => `${quantity} ${name}`)
            .join(', ')}
        </strong>
      );
    case BENEFIT_TYPE.voucher:
      const { quantity, name } = data as VoucherPromotion;
      return <strong>{name ? `${quantity} ${name}` : 'Voucher'}</strong>;
    default:
      return null;
  }
};
export const RelatedPromotion: React.FunctionComponent<
  RelatedPromotionProps
> = ({ promotion }: RelatedPromotionProps) => {
  const { isDefault, benefit, condition, promotionType, type } = promotion;
  const { data, type: benefitType } = benefit;
  // Magento
  if (promotionType === PROMOTION_TYPE.magento) {
    const { coupon, benefit, extraCondition, url } = data as ExtraPromotion;
    return (
      <>
        {t('Nhập mã')} <strong>{coupon}</strong> {t('giảm thêm')}{' '}
        {benefit.discountPercent}
        {t('% tối đa')} <StyledCurrency value={benefit.maxDiscount} />
        {extraCondition} {t('khi thanh toán qua VNPAY-QR.')}
        {url && (
          <Link href={url} target="blank">
            {t('Xem chi tiết')}
          </Link>
        )}
      </>
    );
  }
  // Custom magento
  if (promotionType === PROMOTION_TYPE.customMagento) {
    const { text, url: customUrl } = data as ExtraCustomPromotion;
    return (
      <>
        <span
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
        <Link href={customUrl} target="blank">
          {t('Xem chi tiết')}
        </Link>
      </>
    );
  }
  const isDiscount = benefitType === 'discount';
  const renderPrefixText = () => {
    if (isDefault || type !== 'coupon') {
      return isDiscount ? t('Giảm') : t('Tặng');
    }
    return (
      <>
        {t('Nhập mã')} <strong>{condition?.coupon || ''}</strong>{' '}
        {isDiscount ? t('giảm') : t('tặng')}
      </>
    );
  };
  return (
    <span>
      {renderPrefixText()}{' '}
      {renderDetailPromotionContent(benefitType || '', data)}{' '}
      {t('cho đơn hàng')}{' '}
      {!!condition?.orderValueMin && (
        <>
          {t('từ')} <Currency value={condition.orderValueMin} />
        </>
      )}
      {!!condition?.orderValueMax && (
        <>
          {' '}
          {t('đến')} <Currency value={condition.orderValueMax} />
        </>
      )}{' '}
      {!!condition?.hasProductCondition && t('có sản phẩm này')}
      {isDefault && t('sites.shop-front.components.RelatedPromotion.0')}
    </span>
  );
};
